/*
 * Defensive disable of the product image "click to zoom" behavior.
 *
 * CSS already sets pointer-events:none on .product__media-toggle, which
 * blocks user clicks. This script is belt-and-suspenders for code paths
 * that might dispatch a programmatic click (e.g. a slider init) by:
 *   1. Stopping clicks at capture phase before any theme listener runs.
 *   2. Removing aria-haspopup so screen readers don't announce a dialog
 *      that can't be opened.
 *   3. Removing the data-modal attribute on parent <modal-opener> so the
 *      ModalOpener class can't resolve a modal target.
 */
(function () {
  'use strict';

  function neutralize(root) {
    var toggles = (root || document).querySelectorAll('.product__media-toggle');
    toggles.forEach(function (btn) {
      btn.removeAttribute('aria-haspopup');
      btn.setAttribute('tabindex', '-1');
      var opener = btn.closest('modal-opener.product__modal-opener');
      if (opener) opener.removeAttribute('data-modal');
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target && e.target.closest && e.target.closest('.product__media-toggle');
      if (!t) return;
      e.preventDefault();
      e.stopImmediatePropagation();
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { neutralize(document); });
  } else {
    neutralize(document);
  }

  // Re-run when Shopify section editor rerenders sections.
  document.addEventListener('shopify:section:load', function (e) { neutralize(e.target); });
})();
